import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { Box } from '../box/Box.js';

var AspectRatio = function (_a) {
  var ratio = _a.ratio,
    _b = _a.overflow,
    overflow = _b === void 0 ? "hidden" : _b,
    children = _a.children,
    rest = __rest(_a, ["ratio", "overflow", "children"]);
  var ratioValue = "";
  if (Array.isArray(ratio)) {
    ratioValue = ratio.map(function (r) {
      return 100 / r + "%";
    });
  } else {
    ratioValue = 100 / ratio + "%";
  }
  return React__default.createElement(Box, {
    position: "relative",
    overflow: overflow
  }, React__default.createElement(Box, {
    width: "100%",
    height: 0,
    pb: ratioValue
  }), React__default.createElement(Box, __assign({}, rest, {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }), children));
};
AspectRatio.defaultProps = {
  ratio: 1 / 1
};

export { AspectRatio };
//# sourceMappingURL=AspectRatio.js.map
